import {
  Box,
  Container,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";

interface StructureMember {
  name: string;
  desc: string;
  avatar: string;
  bio: string;
}

const units: StructureMember[] = [
  {
    name: "محمد غواصی کناری",
    desc: "معاون اجرایی",
    avatar: "/images/team-photos/محمد غواصی.png",
    bio: "معاون اجرایی",
  },
  {
    name: "حسین صیادلو",
    desc: "معاون توسعه بازار",
    avatar: "/images/team-photos/حسین صیادلو.png",
    bio: "معاون توسعه بازار",
  },
  {
    name: "عباس ابراهیمی",
    desc: "معاون سرمایه‌گذاری",
    avatar: "/images/team-photos/عباس ابراهیمی.jpg",
    bio: "معاون سرمایه‌گذاری",
  },
  {
    name: "محمدرضا آقامحمد سمسار",
    desc: "معاون عملیات بازار",
    avatar: "/images/team-photos/محمدرضا سمسار.png",
    bio: "معاون عملیات بازار",
  },
  {
    name: "متین عبدی",
    desc: "معاون خدمات مالی",
    avatar: "/images/team-photos/متین عبدی.png",
    bio: "معاون خدمات مالی",
  },
  // {
  //   name: "-",
  //   desc: "مدیر حراست",
  //   avatar: "/images/team-photos/empty.png",
  //   bio: "مدیر حراست",
  // },
  {
    name: "مرجان حامدی",
    desc: "مدیر حسابرسی داخلی",
    avatar: "/images/team-photos/مرجان حامدی.jpg",
    bio: "مدیر حسابرسی داخلی",
  },
  {
    name: "همایون نسیمی",
    desc: "مدیر سیستم ها و روش ها",
    avatar: "/images/team-photos/همایون نسیمی.png",
    bio: "مدیر سیستم ها و روش ها",
  },
  {
    name: "میرسجاد مسجدموسوی",
    desc: "مدیر دارایی",
    avatar: "/images/team-photos/میرسجاد مسجدموسوی.png",
    bio: "مدیر دارایی",
  },
  {
    name: "صادق حجتی میهمان‌دوستی",
    desc: "مدیر مالی",
    avatar: "/images/team-photos/صادق حجتی.png",
    bio: "مدیر مالی",
  },
  {
    name: "میثم امیری پریان",
    desc: "مدیر فناوری اطلاعات",
    avatar: "/images/team-photos/امیری.png",
    bio: "مدیر فناوری اطلاعات",
  },
  {
    name: "اسماعیل ثروتی",
    desc: "مدیر بازاریابی و فروش",
    avatar: "/images/team-photos/اسماعیل ثروتی.png",
    bio: "مدیر بازاریابی و فروش",
  },
  {
    name: "علی حیدری",
    desc: "مدیر تحلیل",
    avatar: "/images/team-photos/حیدری.png",
    bio: "مدیر تحلیل",
  },
  {
    name: "عباس دادرس",
    desc: "مدیر تأمین مالی داخلی",
    avatar: "/images/team-photos/عباس دادرس.png",
    bio: "مدیر تأمین مالی داخلی",
  },
  {
    name: "حامد دانشخواهی",
    desc: "مدیر سرمایه‌گذاری و بازارگردانی",
    avatar: "/images/team-photos/حامد دانشخواهی.png",
    bio: "مدیر سرمایه‌گذاری و بازارگردانی",
  },
  // {
  //   name: "محمدجواد راضی وند",
  //   desc: "مدیر مالی و اجرایی صندوق‌های سرمایه‌گذاری",
  //   avatar: "/images/team-photos/محمدجواد راضی وند.png",
  //   bio: "مدیر مالی و اجرایی صندوق‌های سرمایه‌گذاری",
  // },
  {
    name: "اسماعیل شاه‌زمانی",
    desc: "مدیر مالی و اجرایی صندوق‌های سرمایه‌گذاری",
    avatar: "/images/team-photos/اسماعیل شاه زمانی.png",
    bio: "مدیر مالی و اجرایی صندوق‌های سرمایه‌گذاری",
  },
  {
    name: "مهدی یاری",
    desc: "مدیر ریسک",
    avatar: "/images/team-photos/مهدی یاری.png",
    bio: "مدیر ریسک",
  },
];

export const SectionStructure = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = useState<StructureMember | null>(null);
  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const cardBg = useColorModeValue("white", "dark.300");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const modalBg = useColorModeValue("white", "dark.200");
  const avatarBg = useColorModeValue("brand.50", "brand.200");

  const handleClick = (member: StructureMember) => {
    setSelected(member);
    onOpen();
  };

  return (
    <Box>
      <Container maxW="container.xl">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              ساختار سازمانی و مدیران شرکت
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color={textColor}>
              مدیران ارشد و حوزه‌های مسئولیت آن‌ها
            </Text>
          </VStack>

          <Box display="flex" flexWrap="wrap" justifyContent="center" gap={4}>
            {units.map((unit) => (
              <Box
                key={unit.name}
                flex="0 0 auto"
                w={{
                  base: "calc((100% - 1rem) / 2)",
                  sm: "calc((100% - 2rem) / 3)",
                  lg: "calc((100% - 4rem) / 5)",
                }}
                bg={cardBg}
                borderRadius="xl"
                border="1px solid"
                borderColor={borderColor}
                overflow="hidden"
                cursor="pointer"
                onClick={() => handleClick(unit)}
                _hover={{
                  shadow: "md",
                  borderColor: "brand.200",
                  transform: "translateY(-4px)",
                }}
                transition="all 0.3s"
              >
                {unit.avatar ? (
                  <Image
                    src={unit.avatar}
                    alt={unit.name}
                    w="100%"
                    aspectRatio={1}
                    objectFit="cover"
                  />
                ) : (
                  <Box
                    w="100%"
                    aspectRatio={1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg={avatarBg}
                  >
                    <Text fontSize="3xl" fontWeight="bold" color="brand.500">
                      {unit.name.charAt(0)}
                    </Text>
                  </Box>
                )}
                <VStack spacing={0.5} py={3} px={2}>
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    color={headingColor}
                    textAlign="center"
                  >
                    {unit.name}
                  </Text>
                  <Text fontSize="xs" color={textColor} textAlign="center">
                    {unit.desc}
                  </Text>
                </VStack>
              </Box>
            ))}
          </Box>
        </VStack>
      </Container>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
        <ModalOverlay backdropFilter="blur(4px)" />
        <ModalContent dir="rtl" borderRadius="xl" bg={modalBg}>
          <ModalCloseButton />
          <ModalHeader fontSize="md">{selected?.name}</ModalHeader>
          <ModalBody pb={6}>
            {selected?.avatar ? (
              <Image
                src={selected.avatar}
                alt={selected.name}
                w="100%"
                aspectRatio={1}
                objectFit="cover"
                borderRadius="xl"
                mb={4}
              />
            ) : null}
            <Text fontSize="sm" fontWeight="bold" color="brand.500" mb={2}>
              {selected?.desc}
            </Text>
            <Text fontSize="sm" color={textColor} lineHeight="1.8">
              {selected?.bio}
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
